import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

export interface Props {
  open: boolean;
  onRequestClose: () => void;
  onSubmit: () => void;
  className?: string;
}

const ProposalDialog: FC<Props> = ({ open, onRequestClose, onSubmit, className }) => {
  return (
    <Dialog open={open} onClose={onRequestClose} className={className}>
      <DialogTitle>
        <FormattedMessage id="proposal_adopt_dialog.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage id="proposal_adopt_dialog.description" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onRequestClose} color="default">
          <FormattedMessage id="proposal_adopt_dialog.button.cancel" />
        </Button>
        <Button onClick={onSubmit} color="primary" autoFocus>
          <FormattedMessage id="proposal_adopt_dialog.button.submit" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProposalDialog;
